import { EmployeeReviewActionTypes } from "./EmployeeReview.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE = {
  fetchAll: resetApiCallState([]),
};

const EmployeeReviewReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case EmployeeReviewActionTypes.FETCH_ALL_EMPLOYEE_REVIEW:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case EmployeeReviewActionTypes.FETCH_ALL_EMPLOYEE_REVIEW_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EmployeeReviewActionTypes.FETCH_ALL_EMPLOYEE_REVIEW_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EmployeeReviewActionTypes.FETCH_ALL_EMPLOYEE_REVIEW_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default EmployeeReviewReducer;
